import { Box, LinearProgress } from '@mui/material';
import { useLoadingStore } from '@/shared/api/loadingStore';

export function AppLoader() {
  const isLoading = useLoadingStore((s) => s.isLoading);

  if (!isLoading) return null;

  return (
    <Box sx={{ position: 'fixed', top: 0, left: 0, right: 0, zIndex: 9999 }}>
      <LinearProgress />
    </Box>
  );
}
